import classNames from "classnames";
import React from "react";

import HeatMapItem from "../../heat_map_row/heat_map_item";
import { HeatMap } from "../../heat_map_row/heat_map_item.types";
import css from "../../utilization_row/utilization_item.module.scss";
import { useAvailabilityLabel } from "../hooks/use_availability_label";
import { useBackgroundColor } from "../hooks/use_background_color";

const BORDER_WIDTH = 1;

type AvailabilityItemProps = {
  items: HeatMap[];
};

export const AvailabilityItem = ({ items }: AvailabilityItemProps): JSX.Element => {
  const firstItem = items[0];
  const fullWidth = firstItem.width * items.length - BORDER_WIDTH;
  // eslint-disable-next-line camelcase
  const { available_minutes } = firstItem;
  const availabilityLabel = useAvailabilityLabel({ availableMinutes: available_minutes }); // eslint-disable-line camelcase
  const bgColor = useBackgroundColor({ availableMinutes: available_minutes }); // eslint-disable-line camelcase
  const LABEL_OFFSET = 16;

  const shouldDisplayLabel =
    (available_minutes > 0 && fullWidth > 73 + LABEL_OFFSET) || // eslint-disable-line camelcase
    (available_minutes === 0 && fullWidth > 23 + LABEL_OFFSET) || // eslint-disable-line camelcase
    (available_minutes < 0 && fullWidth > 76 + LABEL_OFFSET); // eslint-disable-line camelcase

  return (
    <HeatMapItem
      {...firstItem}
      left={firstItem.left}
      width={fullWidth}
      rootClassName={css.utilizationItem}
      labelClassName={classNames(css.label)}
      label={availabilityLabel}
      bgColor={bgColor}
      shouldDisplayLabel={shouldDisplayLabel}
    />
  );
};
